<template>
  <div v-if="bottomNavBar != false">
    <section v-if="bottomNavBar=='full'" class="bottomnav">
      <div class="uk-container uk-container-center uk-container-xsmall uk-padding-remove-horizontal" style="padding-bottom: 5px;">
        <div :class="bottomItemCountClass"
             class="uk-text-center" uk-grid>
          <div>
            <router-link to="/coupons">
              <img src="../assets/images/coupon-icon-wht.png" alt="coupons" width="50" height="50">
            </router-link>
          </div>
          <div>
            <router-link to="/locations">
              <img src="../assets/images/locations-icon-wht.png" alt="locations" width="50" height="50">
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <a v-if="!isHideBottomRedemption" href="#"
       v-on:click="redemptionIntent(appConfig.redemption_method,'earn-loyalty', {storeId: null, itemId: null, code: null})">
      <div class="searchbutton uk-text-center"></div>
    </a>
  </div>
</template>

<script>
import _ from 'lodash'
import configMixin from '../mixins/configMixin'
import coreMixin from '../mixins/coreMixin'

const bottomNav = 'full'
export default {
  mixins: [configMixin, coreMixin],
  computed: {
    bottomItemCountClass () {
      let _this = this
      let max = 5
      if (_this.isHideLoyalty) {
        max = max - 1
      }
      if (_this.isHideBottomRedemption) {
        max = max - 1
      }
      if (_this.isAutoLogin) {
        max = max - 1
      }
      return 'uk-child-width-1-' + max
    },
    bottomNavBar () {
      if (this.$route.meta.bottomnav !== '') {
        return this.$route.meta.bottomnav
      } else {
        return bottomNav
      }
    },
    isAutoLogin () {
      return _.get(this.appConfig, 'auto_login')
    },
    isHideLoyalty () {
      return _.get(this.appConfig, 'hide_loyalty')
    },
    isHideBottomRedemption () {
      return _.get(this.appConfig, 'hide_bottom_redemption')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/BottomNav.vue